import type { AxiosRequestConfig } from 'axios';

import { PayRequestType } from '~/shared/api/types/catalog';
import { api } from '~/shared/lib/api';

import { PayOrderResponseSchema } from './payOrder.schema';

export const payOrder = async (
  requestData: PayRequestType,
  options: AxiosRequestConfig = {},
) => {
  const { data: responseData } = await api.post('/api/v1/pay', {
    ...requestData,
    ...options,
  });

  const data = PayOrderResponseSchema.parse(responseData);

  return data;
};
